import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (toolbar: any) => {
    const styles = {};

    if (toolbar?.backgroundColor) {
        styles["--toolbar-background-color"] = toolbar.backgroundColor;
    }

    // Anchor

    if (toolbar?.anchorColor) {
        styles["--toolbar-anchor-text-color"] = toolbar.anchorColor;
    }

    // Location Selector

    if (toolbar?.locationColor) {
        styles["--toolbar-location-color"] = toolbar.locationColor;
    }
    if (toolbar?.locationOverlayColor) {
        styles["--toolbar-location-overlay-color"] = toolbar.locationOverlayColor;
    }
    if (toolbar?.locationOverlayActiveColor) {
        styles["--toolbar-location-overlay-active-color"] = toolbar.locationOverlayActiveColor;
    }

    // Action Button

    const actionButton = toolbar?.actionButtons?.[0] && toolbar.actionButtons.length > 0 ? toolbar.actionButtons[0] : undefined;

    if (actionButton?.content.backgroundColor) {
        styles["--button-override-background-color"] = actionButton.content.backgroundColor;
    }

    if (actionButton?.content.hoverBackgroundColor) {
        styles["--button-override-hover-background-color"] = actionButton.content.hoverBackgroundColor;
    }

    if (actionButton?.content.textColor) {
        styles["--button-override-text-color"] = actionButton.content.textColor;
    }

    if (actionButton?.content.hoverTextColor) {
        styles["--button-override-hover-text-color"] = actionButton.content.hoverTextColor;
    }

    if (actionButton?.content.borderWidth) {
        styles["--button-override-border-width"] = `${actionButton.content.borderWidth}px`;
    }

    if (actionButton?.content.borderColor) {
        styles["--button-override-border-color"] = actionButton.content.borderColor;
    }

    return styles;
};

export default (toolbar?: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(toolbar));

    useEffect(() => {
        setResult(getCssProperties(toolbar));
    }, [toolbar]);

    return result;
};